export default __webpack_public_path__ + "static/media/artImg.bdd751b6.jpg";